import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.95996C12.192 1.95996 12.3767 2.03359 12.516 2.16568C14.533 4.07568 17.254 5.24568 20.25 5.24568L20.393 5.24468C20.5526 5.24267 20.7087 5.29163 20.8385 5.38443C20.9684 5.47723 21.0652 5.60904 21.115 5.76068C21.527 7.01568 21.75 8.35568 21.75 9.74568C21.75 15.6877 17.686 20.6787 12.187 22.0937C12.0643 22.1253 11.9357 22.1253 11.813 22.0937C6.31401 20.6787 2.25001 15.6877 2.25001 9.74568C2.24862 8.39205 2.46298 7.04684 2.88501 5.76068C2.93496 5.60923 3.0319 5.47764 3.16173 5.38503C3.29157 5.29242 3.44754 5.24361 3.60701 5.24568C6.53413 5.28701 9.36128 4.18156 11.484 2.16568C11.6233 2.03359 11.808 1.95996 12 1.95996ZM10.2803 9.79535C9.98744 9.50246 9.51256 9.50246 9.21967 9.79535C8.92678 10.0882 8.92678 10.5631 9.21967 10.856L10.9393 12.5757L9.21967 14.2954C8.92678 14.5882 8.92678 15.0631 9.21967 15.356C9.51256 15.6489 9.98744 15.6489 10.2803 15.356L12 13.6363L13.7197 15.356C14.0126 15.6489 14.4874 15.6489 14.7803 15.356C15.0732 15.0631 15.0732 14.5882 14.7803 14.2954L13.0607 12.5757L14.7803 10.856C15.0732 10.5631 15.0732 10.0882 14.7803 9.79535C14.4874 9.50246 14.0126 9.50246 13.7197 9.79535L12 11.515L10.2803 9.79535Z"
        fill={colorValue}
      />
    </svg>
  );
};
